/** Wraps bare URLs in markdown link syntax, skipping URLs already inside [...](). */
export function convertTextIntoMarkdown(text: string): string {
  const markdownLink = /\[([^\]]+)\]\((https?:\/\/[^)]+)\)/g;
  const bareUrl = /(https?:\/\/[^\s)]+)/g;

  // Collect ranges occupied by existing markdown links
  const occupied: [number, number][] = [];
  let m: null | RegExpExecArray;
  while ((m = markdownLink.exec(text)) !== null) {
    occupied.push([m.index, m.index + m[0].length]);
  }

  // Replace bare URLs that don't fall inside an existing markdown link
  return text.replace(bareUrl, (url, _group, offset: number) => {
    if (occupied.some(([start, end]) => offset >= start && offset < end)) {
      return url;
    }
    return `[${url}](${url})`;
  });
}

export function formatDescription(text: string): string {
  return text.toLowerCase();
}
